import { rdxPopupOpen } from "commons/popup/store/popupR";
import { useDispatch } from "react-redux";
import { PopupType } from "../PopupType";
import { FooterButton } from "./PaymentPopup";
import { useSelectorEq } from "commons/store/common";
import type { IState } from "store/modules";

export const usePaymentPopup = () => {
  const dispatch = useDispatch();
  const showPaymentPopup = async (id: number) => {
    dispatch(
      rdxPopupOpen({
        type: PopupType.PAYMENT_POPUP,
        width: 400,
        data: id,
        isClose: true,
        title: "정산 내역",
        buttonWrapper: FooterButton,
      }),
    );
  };
  return { showPaymentPopup };
};

export const usePaymentPopupInit = (id: number) => {
  const { paymentGridData } = useSelectorEq((state: IState) => ({
    paymentGridData: state.profit.paymentGridData,
  }));

  const data = paymentGridData.filter(i => i.id === id);

  return { data, paymentGridData };
};
